module.exports = __webpack_public_path__ + "img/icon-cart.3af8b491.svg";